"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8655],{

/***/ 71206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ testimonial; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title = __webpack_require__(91265);
;// CONCATENATED MODULE: ./segments/desktop/core-components/testimonial/default-props.js
/* harmony default export */ var default_props = ({
    quote: {
        topic: {},
        title: '"Now that we have monday.com Work OS as the backbone of our organization I feel I have an overview I can trust."',
        body: null
    },
    author: "Charlie MacGregor, Founder & CEO",
    company: {
        title: "The Student Hotel"
    }
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/testimonial/testimonial.scss.js




var mdScreenSize = "".concat(vp_sizes.MD, "px");
var StylesTestimonial = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e17st2q80"
})("display:flex;padding-top:64px;padding-bottom:64px;justify-content:center;height:100%;width:100%;.content{display:flex;gap:45px;width:65%;justify-content:center;flex-direction:column;.quote{font-size:1.875rem;margin-bottom:50px;}.author{display:flex;align-items:center;gap:25px;font-size:1rem;.author-image{width:60px;}.company{font-weight:700;line-height:24px;font-size:1rem;}}}@media (max-width:", mdScreenSize, "){padding:32px 16px;.content{width:100%;gap:24px;line-height:1.5rem;.author-details-container{.author-name{font-size:0.75rem;}.company{font-size:0.75rem;}}.quote{margin-bottom:0;}}}&.white{color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}&.black{color:#000;}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/testimonial/testimonial.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}









var Testimonial = function(param) {
    var quote = param.quote, asset = param.asset, author = param.author, company = param.company, backgroundColor = param.backgroundColor;
    var additionalClassName = (0,react.useMemo)(function() {
        if (!backgroundColor) return;
        return (0,segments_service/* isDarkTheme */.$o)(backgroundColor) ? "white" : "black";
    }, [
        backgroundColor
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StylesTestimonial, {
        className: classnames_default()("testimonial", additionalClassName),
        style: {
            backgroundColor: colors/* default */.Z[backgroundColor]
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "content",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* default */.Z, _object_spread({
                    titleClassName: "quote"
                }, quote)),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "author",
                    children: [
                        (asset === null || asset === void 0 ? void 0 : asset.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, {
                            image: asset,
                            className: "author-image"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "author-details-container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "author-name",
                                    children: author
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* default */.Z, _object_spread({
                                    titleClassName: "company"
                                }, company))
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var testimonial = (Testimonial);
Testimonial.defaultProps = default_props;


/***/ }),

/***/ 78655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CAROUSEL_SETTINGS": function() { return /* binding */ CAROUSEL_SETTINGS; },
  "default": function() { return /* binding */ panorama_cards_carousel_tabs_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/panorama-cards-carousel-tabs/panorama-cards-carousel-tabs-component.scss.js





var StyledPanoramaCardsCarouselTabsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e11q8w960"
})("position:relative;width:calc(100% - 50px);margin:auto;max-width:", vp_sizes/* FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.KI, "px;.tabs-title{padding-bottom:54px;.core-title{font-size:3.5rem;font-weight:200;}}.carousel{position:absolute;right:calc(100vw / 1920 * 50);top:50%;transform:translateY(-50%);width:550px;max-height:700px;z-index:", z_index/* LAYER_TWO */.wc, ";.slick-slider .slick-list{display:flex;transform:scale(0.9);background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";border-radius:40px;.slick-track{padding:0;display:flex;.slick-slide{display:flex;padding:0 8px;.carousel-item{height:100%;}}}}}&.in-card-version{.carousel .slick-slider .slick-list{.slick-track{padding:0 0;.slick-slide .carousel-item .card-component .testimonial-wrapper{gap:20px;}}}}&.with-title{.carousel{top:calc(50% + 50px);}}.background-asset-container{position:relative;z-index:", z_index/* LAYER_ONE */.KW, ";.asset-inner{width:100%;&:not(:first-of-type){position:absolute;left:0;top:0;}&.selected{opacity:1;}opacity:0;transition:opacity ", function(param) {
    var tabTransitionSpeed = param.tabTransitionSpeed;
    return tabTransitionSpeed;
}, "ms;border-radius:40px;object-fit:contain;z-index:", z_index/* HIDDEN */.A1, ";.react-player-video-component video{border-radius:40px;}}}.content{display:flex;justify-content:start;flex-direction:column;.quote{margin-bottom:0;}.author{gap:15px;.company{font-weight:400;}}}@media (max-width:", vp_sizes.LG, "px){.carousel{right:0;.slick-slider .slick-list{transform:scale(0.8);}}&.in-card-version{.carousel .slick-slider .slick-list{transform:scale(0.75);}}}@media (max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px){.carousel{right:-30px;.slick-slider .slick-list{transform:scale(0.74);}}&.in-card-version{.carousel .slick-slider .slick-list{transform:scale(0.7);}}}@media (max-width:", vp_sizes/* MID_HEADER_DESKTOP_MENU */.vc, "px){.carousel{.stats-section{display:none;}}.tabs-title{padding-bottom:54px;.core-title{font-size:2.5rem;font-weight:200;}}}");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/carousel.js + 3 modules
var carousel = __webpack_require__(28391);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/panorama-cards-carousel-tabs/card/card-component.scss.js

var StyledCardComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e19kwhuw0"
})("display:flex;height:100%;border-radius:40px;flex-direction:column;align-items:flex-start;padding:32px;background-color:white;gap:60px;.tab-title{width:100%;display:flex;justify-content:space-between;align-items:center;.asset-inner{img{", function(param) {
    var cardImageHeight = param.cardImageHeight;
    return cardImageHeight ? "height: ".concat(cardImageHeight) : "height: 28px";
}, ";width:auto;}}.carousel-arrows{display:flex;gap:16px;svg{width:40px;height:40px;&:hover{cursor:pointer;}}}}.stats-section{display:grid;grid-template-columns:1fr 1fr 1fr;grid-column-gap:24px;width:100%;.stats{flex-basis:0;flex-grow:1;display:flex;.core-title{font-weight:600;}.vertical-line{width:1px;height:100%;background-color:black;}}}.testimonial-wrapper{display:flex;height:100%;flex-direction:column;justify-content:space-between;gap:70px;.testimonial{padding:0;.content{gap:36px;width:100%;.author{.asset-inner{height:40px;width:40px;}.author-details-container{font-size:0.875rem;.author-name{font-weight:600;}.core-title{font-size:0.875rem;}}}.quote{font-size:1.125rem;line-height:150%;margin-bottom:0;}}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./segments/desktop/core-components/testimonial/testimonial.js + 2 modules
var testimonial_testimonial = __webpack_require__(71206);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/secondary-button/secondary-button.js + 1 modules
var secondary_button = __webpack_require__(95736);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/panorama-cards-carousel-tabs/card/prev-arrow-icon.js

var PrevArrowIcon = function(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        onClick: onClick,
        width: "57",
        height: "57",
        viewBox: "0 0 57 57",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "28.5",
                cy: "28.5",
                r: "28",
                fill: "white",
                stroke: "#DCDFEC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.7929 29.2071C14.4024 28.8166 14.4024 28.1834 14.7929 27.7929L21.1569 21.4289C21.5474 21.0384 22.1805 21.0384 22.5711 21.4289C22.9616 21.8195 22.9616 22.4526 22.5711 22.8431L16.9142 28.5L22.5711 34.1569C22.9616 34.5474 22.9616 35.1805 22.5711 35.5711C22.1805 35.9616 21.5474 35.9616 21.1569 35.5711L14.7929 29.2071ZM41.5 29.5H15.5V27.5H41.5V29.5Z",
                fill: "black"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/panorama-cards-carousel-tabs/card/next-arrow-icon.js

var NextArrowIcon = function(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        onClick: onClick,
        width: "57",
        height: "57",
        viewBox: "0 0 57 57",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "28.5",
                cy: "28.5",
                r: "28",
                transform: "matrix(-1 0 0 1 57 0)",
                fill: "white",
                stroke: "#DCDFEC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M42.2071 29.2071C42.5976 28.8166 42.5976 28.1834 42.2071 27.7929L35.8431 21.4289C35.4526 21.0384 34.8195 21.0384 34.4289 21.4289C34.0384 21.8195 34.0384 22.4526 34.4289 22.8431L40.0858 28.5L34.4289 34.1569C34.0384 34.5474 34.0384 35.1805 34.4289 35.5711C34.8195 35.9616 35.4526 35.9616 35.8431 35.5711L42.2071 29.2071ZM15.5 29.5H41.5V27.5H15.5V29.5Z",
                fill: "black"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/panorama-cards-carousel-tabs/card/card-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}








var DEFAULT_STAT_CONTENT = {
    topic: {}
};
var CardComponent = function(param) {
    var testimonial = param.testimonial, advancedStatsConfig = param.advancedStatsConfig, stats = param.stats, onPrevClick = param.onPrevClick, onNextClick = param.onNextClick, tabTitleImage = param.tabTitleImage, cardImageHeight = param.cardImageHeight;
    var _testimonial_button, _testimonial_button1, _testimonial_button2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardComponent, {
        className: "card-component",
        cardImageHeight: cardImageHeight,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tab-title",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, {
                        image: {
                            src: tabTitleImage
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "carousel-arrows",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrevArrowIcon, {
                                onClick: onPrevClick
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextArrowIcon, {
                                onClick: onNextClick
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "stats-section",
                children: stats === null || stats === void 0 ? void 0 : stats.map(function(statics, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "stats",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, _object_spread({}, DEFAULT_STAT_CONTENT, statics, advancedStatsConfig)),
                            index < stats.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "vertical-line"
                            })
                        ]
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "testimonial-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(testimonial_testimonial/* default */.Z, _object_spread({}, testimonial)),
                    (testimonial === null || testimonial === void 0 ? void 0 : testimonial.button) && /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_button/* default */.Z, {
                        isWithArrow: true,
                        color: (_testimonial_button = testimonial.button) === null || _testimonial_button === void 0 ? void 0 : _testimonial_button.color,
                        url: (_testimonial_button1 = testimonial.button) === null || _testimonial_button1 === void 0 ? void 0 : _testimonial_button1.buttonUrl,
                        buttonText: (_testimonial_button2 = testimonial.button) === null || _testimonial_button2 === void 0 ? void 0 : _testimonial_button2.buttonText,
                        isOpenLinkInNewTab: true
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var card_component = (CardComponent);

// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title = __webpack_require__(91265);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/panorama-cards-carousel-tabs/panorama-cards-carousel-tabs-component.js
function panorama_cards_carousel_tabs_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function panorama_cards_carousel_tabs_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            panorama_cards_carousel_tabs_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var CAROUSEL_SETTINGS = {
    defaultIndex: 0,
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: true,
    centerMode: false,
    swipe: false,
    draggable: false,
    dots: false
};
var DEFAULT_TRANSITION_SPEED = 500;
var EVENT_COMPONENT_NAME = "panorama_cards_carousel_tabs_component";
var PanoramaCardsCarouselTabsComponent = function(param) {
    var tabs = param.tabs, tabAdvancedConfig = param.tabAdvancedConfig, advancedAssetProps = param.advancedAssetProps, transitionSpeed = param.transitionSpeed, autoplay = param.autoplay, autoplaySpeed = param.autoplaySpeed, tabsTitle = param.tabsTitle, inCardVersion = param.inCardVersion;
    var slider = (0,react.useRef)(null);
    var ref = (0,react.useState)(0), selectedTab = ref[0], setSelectedTab = ref[1];
    var slides = (0,react.useMemo)(function() {
        return tabs === null || tabs === void 0 ? void 0 : tabs.map(function(tab) {
            return tab.tabContent;
        });
    }, [
        tabs
    ]);
    var backgroundAssets = (0,react.useMemo)(function() {
        return tabs === null || tabs === void 0 ? void 0 : tabs.map(function(tab) {
            var _tab_tabContent;
            return (_tab_tabContent = tab.tabContent) === null || _tab_tabContent === void 0 ? void 0 : _tab_tabContent.asset;
        });
    }, [
        tabs
    ]);
    var carouselTransitionSpeed = parseInt(transitionSpeed) || DEFAULT_TRANSITION_SPEED;
    var itemRenderer = function(tab) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(card_component, panorama_cards_carousel_tabs_component_object_spread({
            onNextClick: onNextClick,
            onPrevClick: onPrevClick
        }, tab, tabAdvancedConfig));
    };
    var onNextClick = function() {
        setSelectedTab(function(currentTab) {
            return Math.abs((currentTab + 1) % slides.length);
        });
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.CAROUSEL_ARROW_CLICKED, {
            info1: EVENT_COMPONENT_NAME,
            info3: "next"
        });
        slider === null || slider === void 0 ? void 0 : slider.current.next();
    };
    var onPrevClick = function() {
        setSelectedTab(function(currentTab) {
            return (currentTab - 1 + slides.length) % slides.length;
        });
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.CAROUSEL_ARROW_CLICKED, {
            info1: EVENT_COMPONENT_NAME,
            info3: "prev"
        });
        slider === null || slider === void 0 ? void 0 : slider.current.prev();
    };
    var onSlideChange = function(index) {
        var didChangedByClick = index !== selectedTab;
        if (didChangedByClick) {
            setSelectedTab(index);
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.CAROUSEL_TAB_CLICKED, {
                info1: index + 1
            });
        }
    };
    var handleBeforeChange = function(oldIndex, newIndex) {
        setSelectedTab(newIndex);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPanoramaCardsCarouselTabsComponent, {
        tabTransitionSpeed: carouselTransitionSpeed,
        className: classnames_default()("panorama-cards-carousel-tabs-component", {
            "in-card-version": inCardVersion,
            "with-title": tabsTitle
        }),
        children: [
            tabsTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tabs-title",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* default */.Z, {
                    title: tabsTitle
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.Z, panorama_cards_carousel_tabs_component_object_spread({
                slidesToShow: 1,
                speed: carouselTransitionSpeed,
                itemRenderer: itemRenderer,
                items: slides,
                ref: slider,
                autoplay: autoplay,
                autoplaySpeed: autoplaySpeed,
                beforeChange: handleBeforeChange
            }, CAROUSEL_SETTINGS)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "background-asset-container",
                children: backgroundAssets.map(function(asset, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread_props(panorama_cards_carousel_tabs_component_object_spread({}, asset, advancedAssetProps), {
                        className: classnames_default()({
                            selected: index === selectedTab
                        })
                    }), index);
                })
            })
        ]
    });
};
/* harmony default export */ var panorama_cards_carousel_tabs_component = (PanoramaCardsCarouselTabsComponent);


/***/ })

}]);